<template>
  <div class="input-wrapper">
    <p class="floating-placeholder" v-if="floating" :class="{'focus-placeholder':(isFocus)}">{{placeholder}}</p>
    <p class="validate" v-if="validate">{{validate}}</p>
    <input
      class="nerz-input"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      @input="updateValue"
      @focus="floatingPlaceholder"
      @blur="blurPlaceholder"
      @change="chargeRifleInput"
    />
  </div>
</template>

<script>
export default {
  name: "Input",
  props: {
    value: { type: [String, Number] },
    type: { type: String },
    placeholder: { type: String, required: false },
    max: {type: Number},
    min: {type: Number},
    action: {type: Object},
    validate: {type: String},
  },
  data() {
    return {
      floating: false,
      isFocus: false,
    }
  },

  mounted() {
    this.checkVal()
  },

  methods: {
    updateValue: function(e) {
      this.$emit('input', e.target.value)
      if(this.$listeners.nullCheckVal) {
        this.$emit('nullCheckVal')
      }
      if(this.$listeners.animeSearch) {
        this.$emit('animeSearch')
      }
      this.checkVal()
    },

    checkVal() {
      if(this.value) {
        this.floating = true
      } else {
        this.floating = false
      }
    },

    floatingPlaceholder() {
      this.isFocus = true
    },

    blurPlaceholder() {
      this.isFocus = false
      this.checkVal()
      if(this.action && this.action.where == 'blur') {
        this.$emit(this.action.method)
      }
    },

    chargeRifleInput() {
      this.$emit('chargeRifleInput')
    }
  }
};

//chargeRifleInput()はchangeInputとchargeInputとtypoして動かなかったのでイラついてつけた名前(うぃーーーんばこーーーんｗｗｗｗ)
</script>

<style scoped>

.input-wrapper {
  width: 100%;
}

.nerz-input {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: normal;
  width: 100%;
  margin: auto;
  padding: 10px 5px;
  font-size: 16px;
  appearance: none;
  border: none;
  border-bottom: 1px solid #868686;
  background: transparent!important;
  padding-top: 0;
  border-radius: 0;
  outline: none;
}

.nerz-input:focus {
  border-bottom: 2px solid #f3983b;
  outline: 0;
}

.nerz-input-unauthenticated:focus {
  border-bottom: 2px solid red;
  outline: 0;
}

input:-webkit-autofill {
  -webkit-transition: background-color 9999s;
  transition: background-color 9999s;
  border: none;
}

.floating-placeholder {
  font-size: 12px;
  line-height: 0;
  margin-block-end: 0px;
  margin-bottom: 5px!important;
  margin-left: 5px;
  color: #515659;
  font-weight: bold;
}

.focus-placeholder {
  color: #f3983b;
}

::placeholder {
  font-size: 14px;
}

</style>
